import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonContent,
  IonText,
} from '@ionic/react';
import { MarkdownEditor } from './MarkdownEditor';
import { MarkdownComposerActions } from './MarkdownComposerActions';

interface MarkdownComposerModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  loading?: boolean;
  errorMessage?: string | null;
  placeholder?: string;
  maxLength?: number;
  submitLabel?: string;
  cancelLabel?: string;
}

export const MarkdownComposerModal = ({
  isOpen,
  onDismiss,
  value,
  onChange,
  onSubmit,
  loading = false,
  errorMessage = null,
  placeholder,
  maxLength,
  submitLabel = 'Enviar',
  cancelLabel = 'Cancelar',
}: MarkdownComposerModalProps) => {
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onDismiss}>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <div className="w-full py-2">
            <MarkdownComposerActions
              onCancel={onDismiss}
              onSubmit={onSubmit}
              loading={loading}
              submitDisabled={!value.trim()}
              submitLabel={submitLabel}
              cancelLabel={cancelLabel}
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <MarkdownEditor
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={loading}
        />

        {errorMessage && (
          <IonText color="danger">
            <p className="mt-3 text-sm">{errorMessage}</p>
          </IonText>
        )}
      </IonContent>
    </IonModal>
  );
};
